import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { HeadingPriority } from "atoms/constants/heading-priority";
import { siteMap } from "internal-sitemap";
import { t } from "i18next";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import { useHistory } from "react-router";
import Button from "atoms/buttons/button";
import Heading from "atoms/typography/heading";
import ProfileAvatar from "organisms/profile/profile-avatar";
import React from "react";
import useNetworkInformation from "utilities/contexts/network-information/use-network-information";
import { Breakpoints } from "utilities/enumerations/breakpoints";
import useBreakpoint from "utilities/hooks/use-breakpoint";

const CSS_CLASS_NAME = "c-dashboard-user-profile";

const DashboardUserProfile = () => {
    const { globalState } = useGlobalState();
    const { isOnline } = useNetworkInformation();
    const isDesktop = useBreakpoint(Breakpoints.Tablet);
    const fullName =
        globalState.currentIdentity?.user?.getFirstAndLastNameOrReturnDefault();
    const history = useHistory();
    const showTeamName = globalState.currentIdentity?.isGroupMember();
    const teamName =
        globalState.currentIdentity?.getCurrentTeam()?.name ??
        t("unassignedTeam");
    const handleManageTeamClick = () => {
        history.push(siteMap.account.team);
    };

    const manageTeamButtonStyle = isOnline
        ? ButtonStyles.Secondary
        : ButtonStyles.Primary;

    return (
        <div className={`${CSS_CLASS_NAME}`}>
            {isDesktop && (
                <div className={`${CSS_CLASS_NAME}__avatar`}>
                    <ProfileAvatar />
                </div>
            )}
            <div className={`${CSS_CLASS_NAME}__info`}>
                <Heading
                    priority={HeadingPriority.Four}
                    cssClassName={`${CSS_CLASS_NAME}__fullName`}>
                    {fullName}
                </Heading>
                {showTeamName && (
                    <Heading
                        priority={HeadingPriority.Five}
                        cssClassName={`${CSS_CLASS_NAME}__teamName`}>
                        {teamName}
                    </Heading>
                )}
            </div>
            {globalState.currentIdentity?.isAdminOfCurrentGroup() && (
                <Button
                    disabled={!isOnline}
                    onClick={handleManageTeamClick}
                    cssClassName={`${CSS_CLASS_NAME}__button`}
                    style={manageTeamButtonStyle}
                    size={ButtonSizes.Small}>
                    {t("manageTeam")}
                </Button>
            )}
        </div>
    );
};

export default DashboardUserProfile;
